export default __webpack_public_path__ + "static/media/Youtube.527785fa.svg";